import adjustmentTools from "./adjustment-tools";

const baseUrl = "/entry";

export default [
  {
    icon: "mdi-database",
    key: "title.itemLedgerEntry",
    link: baseUrl + "/item-ledger-entry",
    // items: postingGroup,
    level: 2,
    keywords: "item ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.valueEntry",
    link: baseUrl + "/value-entry",
    // items: generalLedgerSetup,
    level: 2,
    keywords: "value entry",
  },
  {
    icon: "mdi-database",
    key: "title.bankAccountLedgerEntry",
    link: baseUrl + "/bank-account-ledger-entry",
    level: 2,
    keywords: "bank account ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.bankAccountLedgerEntryDetail",
    link: baseUrl + "/bank-account-ledger-entry-detail",
    level: 2,
    keywords: "bank account ledger entry detail",
  },
  {
    icon: "mdi-database",
    key: "title.depositAccountLedgerEntry",
    link: baseUrl + "/deposit-account-ledger-entry",
    level: 2,
    keywords: "deposit account ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.depositAccountLedgerEntryDetail",
    link: baseUrl + "/deposit-account-ledger-entry-detail",
    level: 2,
    keywords: "deposit account ledger entry detail",
  },
  {
    icon: "mdi-database",
    key: "title.generalLedgerEntry",
    link: baseUrl + "/general-ledger-entry",
    // items: postingGroup,
    level: 2,
    keywords: "general ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.physicalInventoryLedgerEntry",
    link: baseUrl + "/physical-inventory-ledger-entry",
    // items: postingGroup,
    level: 2,
    keywords: "physical inventory ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.vatEntry",
    link: baseUrl + "/vat-entry",
    // items: generalLedgerSetup,
    level: 2,
    keywords: "vat entry",
  },
  {
    icon: "mdi-database",
    key: "title.itemApplicationEntry",
    link: baseUrl + "/item-application-entry",
    // items: postingGroup,
    level: 2,
    keywords: "item application entry",
  },
  {
    icon: "mdi-database",
    key: "title.averageCostCalculationEntry",
    link: baseUrl + "/average-cost-calculation-entry",
    // items: generalLedgerSetup,
    level: 2,
    keywords: "average cost calculation entry",
  },
  {
    icon: "mdi-database",
    key: "title.vendorLedgerEntry",
    link: baseUrl + "/vendor-ledger-entry",
    // items: postingGroup,
    level: 2,
    keywords: "vendor ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.vendorLedgerEntryDetail",
    link: baseUrl + "/vendor-ledger-entry-detail",
    // items: generalLedgerSetup,
    level: 2,
    keywords: "vendor ledger entry detail",
  },

  {
    icon: "mdi-database",
    key: "title.clientLedgerEntry",
    link: baseUrl + "/client-ledger-entry",
    // items: postingGroup,
    level: 2,
    keywords: "client ledger entry",
  },
  {
    icon: "mdi-database",
    key: "title.clientLedgerEntryDetail",
    link: baseUrl + "/client-ledger-entry-detail",
    // items: generalLedgerSetup,
    level: 2,
    keywords: "client ledger entry detail",
  },
  {
    icon: "mdi-database",
    key: "title.generalJournalEntry",
    link: baseUrl + "/general-journal-entry",
    level: 2,
    keywords: "general journal entry",
  },
  {
    icon: "mdi-database",
    key: "title.itemJournalLog",
    link: baseUrl + "/item-journal-log",
    level: 2,
    keywords: "item journal log",
  },
  {
    icon: "mdi-database",
    key: "title.adjustmentTools",
    link: baseUrl + "/entries-adjustment-tools",
    items: adjustmentTools,
    level: 2,
    keywords: "posting setup",
  },
];
